module.exports = __webpack_public_path__ + "images/hitachi820b42d8f12928a109ebfc6935810e60.png";